import { store } from "infrastructure/store/ConfigureStore";
import {
  setGridPaginationUrlParams,
  setGridPaginationPageSize,
} from "infrastructure/store/dataGrid/DataGridActions";
import { injectable } from "inversify";
import IPaginationHandler from "./IPaginationHandler";

@injectable()
export default class PaginationHandler implements IPaginationHandler {

  storeSetDefaultParams(
    dataGridId: string,
    urlParams: URLSearchParams,
    page: number,
    pageSize: number
  ): void {
    if (!urlParams.get("Page")) {
        urlParams.set("Page", page.toString());    
    }

    if(!urlParams.get("PageSize")) {
        urlParams.set("PageSize", pageSize.toString());
    }    

     store.dispatch(
      setGridPaginationUrlParams({
        key: dataGridId,
        value: urlParams.toString(),
      })
    );

    store.dispatch(
      setGridPaginationPageSize({
        key: dataGridId,
        value: pageSize,
      })
    );
  }

  storeSetPagination(
    dataGridId: string,
    urlParams: URLSearchParams,
    page: number,
  ): void {    
    urlParams.set("Page", page.toString());

    store.dispatch(
      setGridPaginationUrlParams({
        key: dataGridId,
        value: urlParams.toString(),
      })
    );
  }
}
